import { moneyFormater } from "../../../../../utilities/formaters";

export function boolRenderer(value) {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "not set";
}

export function getRejectReasonText(offer) {
  if (offer.RejectReason == null) return "Not rejected";

  switch (offer.RejectReason) {
    case "Manual":
      return "Manual";
    case "Kalp":
      return "Kalp";
    case "Score":
      return "Kreditz Score";
    case "InstantLoans":
      return "Instant Loans";
    default:
      return "Reason missing";
  }
}

export const CreditDecisionEnum = {
  Rejected: "Rejected",
  Approved: "Approved",
};

export const isApproved = (offer) =>
  offer.CreditDecision === CreditDecisionEnum.Approved;
export const isRejected = (offer) =>
  offer.CreditDecision === CreditDecisionEnum.Rejected;

export function getOfferStyle(offer) {
  if (offer.IsSigned) return OfferStyle.Accepted;
  if (isRejected(offer)) return OfferStyle.Rejected;
  if (isApproved(offer)) return OfferStyle.Approved;
  return OfferStyle.Regular;
}

export const OfferStyle = {
  Borderless: { color: "grey", width: "200px", float: "left", padding: "4px" },
  Regular: {
    color: "grey",
    border: "1px solid rgb(217, 217, 217)",
    width: "200px",
    float: "left",
    padding: "4px",
  },
  Approved: {
    color: "black",
    border: "1px solid rgb(217, 217, 217)",
    width: "200px",
    float: "left",
    padding: "4px",
  },
  Accepted: {
    color: "black",
    border: "1px solid rgb(217, 217, 217)",
    width: "200px",
    float: "left",
    padding: "4px",
  },
  Rejected: {
    color: "black",
    backgroundColor: "lightgrey",
    border: "1px solid rgb(217, 217, 217)",
    width: "200px",
    float: "left",
    padding: "4px",
  },
};

export function showCurrencyIfSet(amount) {
  return amount ? moneyFormater(amount) + "kr" : "not set";
}
